<template>
  <div v-if="loading">
    <div class="text-center text-primary my-2">
      <b-spinner type="grow" class="align-middle"></b-spinner>
    </div>
  </div>
  <div v-else>
    <div class="row mb-3">
      <div class="col-6">
        <p>
          {{ $t('closetheloop.reviewSubmission.description') }}
        </p>

        <ul>
          <li>
            <span class="idx-bold">
              {{ $t('closetheloop.reviewSubmission.answersTotal') }}:
            </span>
            <span>{{ this.totalAnswers }} </span>
          </li>

          <br />

          <li>
            <span class="idx-bold">
              {{ $t('closetheloop.reviewSubmission.appliedFilters') }}:
            </span>
            <ul>
              <li>
                {{ $t('closetheloop.reviewSubmission.action') }}:
                {{ this.filterLabels.actionName }}
              </li>
              <li>
                {{ $t('closetheloop.reviewSubmission.metric') }}:
                {{ this.filterLabels.metric }}
              </li>
              <li>
                {{ $t('closetheloop.reviewSubmission.startDate') }}:
                {{
                  this.filterLabels.startDate ||
                  $t('closetheloop.reviewSubmission.allPeriod')
                }}
              </li>
              <li>
                {{ $t('closetheloop.reviewSubmission.endDate') }}:
                {{
                  this.filterLabels.endDate ||
                  $t('closetheloop.reviewSubmission.allPeriod')
                }}
              </li>
              <li v-if="this.filterLabels.searchField">
                {{ $t('closetheloop.reviewSubmission.search') }}:
                {{ this.filterLabels.searchField }}
              </li>
              <li v-if="this.filterLabels.ih1">
                {{ $t('closetheloop.reviewSubmission.ih1') }}:
                {{ this.filterLabels.ih1 }}
              </li>
              <li v-if="this.filterLabels.ih2">
                {{ $t('closetheloop.reviewSubmission.ih2') }}:
                {{ this.filterLabels.ih2 }}
              </li>
              <li v-if="this.filterLabels.profile">
                {{ $t('closetheloop.reviewSubmission.profile') }}:
                {{ this.filterLabels.profile }}
              </li>
              <li v-if="this.filterLabels.indicatorValue">
                {{ $t('closetheloop.reviewSubmission.indicator') }}:
                {{ this.filterLabels.indicatorValue }}
              </li>
              <li v-if="this.filterLabels.category">
                {{ $t('closetheloop.reviewSubmission.category') }}:
                {{ this.filterLabels.category }}
              </li>
              <li v-if="this.filterLabels.status">
                Status:
                {{ this.filterLabels.status }}
              </li>
              <li v-if="this.filterLabels.responsible">
                {{ $t('closetheloop.reviewSubmission.responsible') }}:
                {{ this.filterLabels.responsible }}
              </li>
              <li v-if="this.filterLabels.comment">
                {{ $t('closetheloop.reviewSubmission.comment') }}:
                {{
                  this.filterLabels.comment === 'noComments'
                    ? 'Sem comentários'
                    : 'Com comentários'
                }}
              </li>
              <li v-if="this.filterLabels.anonymous">
                {{ $t('closetheloop.reviewSubmission.anonymous') }}:
                {{ this.filterLabels.anonymous }}
              </li>
            </ul>
          </li>

          <br />

          <li>
            <span class="idx-bold">
              {{ $t('closetheloop.reviewSubmission.configTemplate') }}:
            </span>
            <span>{{ this.stepTwoInfo.templateSelected }}</span>
          </li>

          <br />

          <li>
            <span class="idx-bold">
              {{ $t('closetheloop.reviewSubmission.sendStatus') }}:
            </span>
            <span>{{ this.stepTwoInfo.status }}</span>
          </li>

          <br />

          <li>
            <span class="idx-bold">
              {{ $t('closetheloop.reviewSubmission.responsible') }}:
            </span>
            <span>{{ this.userAuth.name }}</span>
          </li>
        </ul>
      </div>
      <div class="col-6">
        <div class="email">
          <div class="email-header">
            <div class="pull-right">
              <img
                width="50"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Minimize_Maximize_Close_Icons.svg/120px-Minimize_Maximize_Close_Icons.svg.png"
                alt=""
              />
            </div>
          </div>

          <div class="email-sub-header">
            <div class="row">
              <div class="col-6">
                <h4><strong>IndeCX</strong></h4>
                <p>{{ this.stepTwoInfo.email.subject }}</p>
                <p>
                  De:
                  <span style="color: #cccccc;">{{
                    this.stepTwoInfo.email.sender
                  }}</span>
                </p>
              </div>
              <div class="col-6 text-right">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path
                    d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"
                    fill="#cccccc"
                    class="color000 svgShape"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="#cccccc"
                    class="color000 svgShape"
                    d="M10 9V7.41c0-.89-1.08-1.34-1.71-.71L3.7 11.29c-.39.39-.39 1.02 0 1.41l4.59 4.59c.63.63 1.71.19 1.71-.7V14.9c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
                  />
                </svg>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="#cccccc"
                    class="color000 svgShape"
                    d="M7 7.56c0-.94-1.14-1.42-1.81-.75L.71 11.29c-.39.39-.39 1.02 0 1.41l4.48 4.48c.67.68 1.81.2 1.81-.74 0-.28-.11-.55-.31-.75L3 12l3.69-3.69c.2-.2.31-.47.31-.75zM13 9V7.41c0-.89-1.08-1.34-1.71-.71L6.7 11.29c-.39.39-.39 1.02 0 1.41l4.59 4.59c.63.63 1.71.18 1.71-.71V14.9c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
                  />
                </svg>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 92 92"
                >
                  <path
                    fill="#cccccc"
                    class="color000 svgShape"
                    d="M13 75c-.3 0-.7 0-1-.1-1.8-.5-3-2-3-3.9 0-.6.1-15.9 11.5-27.3 7.3-7.3 17.3-11.3 29.9-12V21c0-1.6 1-3.1 2.5-3.7 1.5-.6 3.2-.3 4.4.9l24.6 25c1.5 1.6 1.5 4.1 0 5.6l-24.6 25c-1.1 1.2-2.9 1.5-4.4.9-1.5-.6-2.5-2.1-2.5-3.7V60.2c-8-.2-27 .6-33.9 12.8-.7 1.2-2.1 2-3.5 2zm35.2-22.9c3.7 0 6.3.3 6.6.3 2 .2 3.6 1.9 3.6 4v4.8l15-15.2-15-15.2v4.8c0 2.2-1.8 4-4 4-12.3 0-21.8 3.3-28.2 9.8-2.9 2.9-4.9 6.2-6.3 9.3 9.3-5.6 21.1-6.6 28.3-6.6z"
                  />
                </svg>
              </div>
            </div>
          </div>

          <hr />
          <div class="email-body" v-html="this.stepTwoInfo.email.html"></div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <button class="btn btn-info" @click="step = 2">
          {{ $t('closetheloop.goBackButton') }}
        </button>
        <button class="btn btn-info" @click="sendEmails">
          {{ $t('closetheloop.sendButton') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import swal from 'sweetalert';
import api from '../../../../services/api';

export default {
  props: {
    stepOneInfo: Object,
    stepTwoInfo: Object,
  },

  data: () => ({
    userAuth: {},
    loading: true,
    totalAnswers: 0,
    filterLabels: {},
    filterValues: {},
  }),

  computed: {
    ...mapFields('closetheloop', ['step', 'submitDone']),
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.submitDone = false;

    this.filterValues = {
      ids: this.stepOneInfo.ids || [],
      all: this.stepOneInfo.all || null,
      ...this.stepOneInfo.filtersSelected,
    };

    this.filterLabels = {
      ...this.stepOneInfo.reviewInfo,
    };

    await this.getTotalAnswers();

    this.loading = false;
  },

  mounted() {},

  methods: {
    async getTotalAnswers() {
      const response = await api.post(
        '/close-the-loop/send',
        {
          ...this.filterValues,
          reviewSubmission: true,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      this.totalAnswers = response.data.qty;
    },

    async sendEmails() {
      try {
        await api.post(
          '/close-the-loop/send',
          {
            ...this.filterValues,
            emailHtml: this.stepTwoInfo.email.html,
            emailSender: this.stepTwoInfo.email.sender,
            emailSubject: this.stepTwoInfo.email.subject,
            treatmentResponsible: this.stepTwoInfo.responsible,
            treatmentStatus: this.stepTwoInfo.status,
            submit: true,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        swal(
          this.$t('closetheloop.reviewSubmission.submitTitle'),
          this.$t('closetheloop.reviewSubmission.submitDescription'),
          'success',
        );

        this.step = 1;
        this.submitDone = true;
      } catch (error) {
        window.console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.email {
  border-radius: 16px;
  min-height: 300px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.email-header {
  padding: 8px;
  padding-right: 15px;
  height: 40px;
  border-top-left-radius: 18px;
  border-top-right-radius: 16px;
  background: #ededed;
}
.email-sub-header {
  padding: 10px;
  h4,
  p {
    margin: 0;
    padding: 0;
    font-size: 90%;
  }
}
.email-body {
  height: 350px;
  overflow: hidden;
  overflow-y: scroll;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/closetheloop/review-submission/index.vue